import styled, { CSSObject } from '@emotion/styled';
import { FONT_FAMILIES } from 'theme/material/constants';
import { isDarkMode } from 'utils/helpers';

export const FormContainer = styled('div')({
  maxWidth: '100%',
  paddingBottom: 20,
});

export const FormWrapper = styled('div')({
  maxWidth: '100%',
});

export const ButtonAction = styled('div')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  paddingTop: 20,
  paddingBottom: 10,
});

export const Heading = styled('h4')(
  (): CSSObject => ({
    fontSize: 24,
    fontWeight: 400,
    fontFamily: FONT_FAMILIES.secondary,
    letterSpacing: '-0.3px',
    color: isDarkMode() ? '#CFCFCF' : '#333333',
  })
);

export const Heading1 = styled('h3')({
  fontSize: 24,
  fontWeight: 700,
  color: '#2B8FD7',
});

export const LinkAction = styled('span')({
  color: '#2B8FD7',
  textDecoration: 'underline',
  cursor: 'pointer',
  fontWeight: 700,
  marginLeft: 5,
});

export const Description = styled('div')(
  (): CSSObject => ({
    marginTop: 15,
    color: isDarkMode() ? '#AFB0B1' : '#595959',
    letterSpacing: '-0.3px',
    lineHeight: '20px',
  })
);

export const DashlineSeparator = styled('span')({
  width: '100%',
  display: 'block',
  borderTop: '1px dashed #DAE1E9',
  marginTop: 20,
});

export const StyledContainer = styled('div')({
  textAlign: 'center',
  maxWidth: 345,
  margin: 'auto',
  paddingTop: 20,
});

export const ErrorMessage = styled('p')({
  color: 'red',
  fontSize: 14,
});

export const StyledEditablePhoneInput = styled('div')({
  display: 'flex',
});

export const StyledRemovePhone = styled('button')({
  display: 'flex',
  backgroundColor: 'transparent',
  padding: 0,
  border: 'none',
  fontSize: 13,
  fontStyle: 'normal',
  textDecoration: 'underline',
  fontWeight: 400,
  color: '#2B8FD7',
  marginTop: 5,
  textTransform: 'none',
  '&:hover': {
    textDecoration: 'none',
  },
});
